import { ReactNode } from 'react';
import { Dispatch } from 'redux';
import getRelayEnvironment from '../../../relayClientEnvironment';
import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

async function importTradeRewardsEndOfYearMessagingModal(): Promise<ReactNode> {
    const mod = await import(
        /* webpackChunkName: "TradeRewardsEndOfYearMessaging" */
        '../../../TradeRewardsEndOfYearMessagingModal/TradeRewardsEndOfYearMessagingModal'
    );
    return mod.TradeRewardsEndOfYearMessagingModal;
}

type CustomActionType = {
    customActionType: {
        actionType: string;
    };
};

export const tradeRewardsEndOfYearMessagingAction = ({
    customActionType,
}: CustomActionType): $TSFixMe => (dispatch: Dispatch) => {
    importModuleAndRenderNotification({
        importFunc: importTradeRewardsEndOfYearMessagingModal,
        containerClassName: 'tradeRewardsEndOfYearMessagingModalContainer',
        props: {
            openOnRender: true,
            environment: getRelayEnvironment(),
        },
    });

    return dispatch({ type: customActionType.actionType });
};
